import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ErrorImg from '@assets/images/backgrounds/errorimg.svg';

const Error = () => (
  <Box
    display="flex"
    flexDirection="column"
    height="100vh"
    textAlign="center"
    justifyContent="center"
  >
    <Container maxWidth="md">
      <img src={ErrorImg} alt="404" />
      <Typography align="center" variant="h1" mb={4}>
        Opps!!!
      </Typography>
      <Typography align="center" variant="h4" mb={4}>
        Hệ thống đang xảy ra sự cố, vui lòng trở về trang chủ để tiếp tục nhé!
      </Typography>
      <Button
        color="primary"
        variant="contained"
        component={Link}
        onClick={() => window.location.replace("/")}
        disableElevation
      >
        Trở về trang chủ
      </Button>
    </Container>
  </Box>
);

export default Error;
